import { render, staticRenderFns } from "./UiCameraFrame.vue?vue&type=template&id=1550d8e7&scoped=true"
import script from "./UiCameraFrame.vue?vue&type=script&lang=js"
export * from "./UiCameraFrame.vue?vue&type=script&lang=js"
import style0 from "./UiCameraFrame.vue?vue&type=style&index=0&id=1550d8e7&prod&scoped=true&lang=css"
import style1 from "./UiCameraFrame.vue?vue&type=style&index=1&id=1550d8e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1550d8e7",
  null
  
)

export default component.exports